export class User {
    name: string;
    email: string;
    token: string;

    public constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }
}
